import clsx from 'clsx'
import React, { FC } from 'react'

import styles from './DeliveryLogo.module.scss'

export const ShippingLogo: FC<{
  className?: string
  deliveryType: string
  onImageError?: () => void
  url: string | null | undefined
}> = ({
  className,
  deliveryType,
  onImageError,
  url,
}) => (
  <img
    alt={deliveryType}
    className={clsx(styles.deliveryLogo, styles[deliveryType], className)}
    onError={({ currentTarget }) => {
      if (onImageError) {
        onImageError()
      }
      if (currentTarget) {
        // eslint-disable-next-line no-param-reassign
        currentTarget.style.display = 'none'
      }
    }}
    src={url || ''}
  />
)
